module.exports = __webpack_public_path__ + "static/media/sports03.3aeb70be.jpg";